<template>
    <setup_content v-if="active_step == 'profitable_step2'" title="Ставка капитализации">

        <template v-slot:buttons>
            <div  v-if="!not_editable" class="d-flex justify-content-center mb-2" style="gap: .625rem;">
                <b-button v-if="data.type == 'Метод рыночной экстракции (на основе группы пар данных)' || data.type == 'Метод рыночной экстракции (на основе пары групп данных)'"
                    variant="outline-primary-secondary"
                    @click="() => $emit('set_active_step', 'profitable_step2_1')"
                >
                    <span>Настроить расчет</span><base-icon name="settings" size="md" />
                </b-button>
            </div>
        </template>

        <div class="element-row mb-3" v-if="!not_editable">
            <label class="element-row_label"><span>Выберите способ расчета</span></label>
            <div class="element-row_fields">
                <b-form-radio-group
                    :checked="data.type"
                    @change="(value) => set_value('type', value)"
                    :options="options"
                    stacked :disabled="!check_roles([ 'model' ])"
                />
            </div>
        </div>

        <template v-if="!not_editable">
        <setup_frame v-if="data.type == 'Данные Пользователя'" title="Данные Пользователя">

            <element_row
                title="Ставка капитализации" :data="data.custom"
                :validation="fields['custom']" v-on:set_value="(key, value) => set_value(`custom.${key}`, value)"
                :readonly="!check_roles([ 'model' ])"
            />

        </setup_frame>

        <setup_frame v-else-if="data.type == 'Метод кумулятивного построения'" title="Метод кумулятивного построения">
            <element_row
                title="Безрисковая ставка" :data="data.cumulative.risk_free_rate"
                :validation="fields['cumulative.risk_free_rate']" v-on:set_value="(key, value) => set_value(`cumulative.risk_free_rate.${key}`, value)"
                :readonly="!check_roles([ 'model' ])"
            />

            <element_row
                title="Надбавка за низкую ликвидность объекта недвижимости" :data="data.cumulative.premium"
                :validation="fields['cumulative.premium']" v-on:set_value="(key, value) => set_value(`cumulative.premium.${key}`, value)"
                :readonly="!check_roles([ 'model' ])"
            />

            <element_row
                title="Суммарный риск инвестирования в объект недвижимости" :data="data.cumulative.total_risk"
                :validation="fields['cumulative.total_risk']" v-on:set_value="(key, value) => set_value(`cumulative.total_risk.${key}`, value)"
                :readonly="!check_roles([ 'model' ])"
            />

            <element_row
                title="Норма возврата капитала" :data="data.cumulative.norm"
                :validation="fields['cumulative.norm']" v-on:set_value="(key, value) => set_value(`cumulative.norm.${key}`, value)"
                :readonly="!check_roles([ 'model' ])"
            />

            <element_row title="Ставка капитализации" :data="{ value : data.cumulative.value }" readonly without_source not_required bold />
        </setup_frame>
        </template>

        <template v-else>
            <div class="element-row mb-3">
                <label class="element-row_label"><span>Способ расчета</span></label>
                <div class="element-row_fields">{{ data.type }}</div>
            </div>

            <element_row title="Ставка капитализации" v-if="not_editable && not_editable_data" :data="not_editable_data" readonly not_required bold />
        </template>

    </setup_content>
    
    <!-- Группы пар -->
    <pair_groups v-else-if="active_step == 'profitable_step2_2' && data.type == 'Метод рыночной экстракции (на основе группы пар данных)'"
		:id="id" :data="data" :group_id="group_id"
    />
    <!-- Пары групп -->
    <group_pairs v-else-if="active_step == 'profitable_step2_2' && data.type == 'Метод рыночной экстракции (на основе пары групп данных)'"
        :id="id" :data="data.group_pairs" :group_id="group_id"
    />

    <setup_content v-else-if="active_step == 'profitable_step2_1'" title="Чистый операционный доход объектов-аналогов (руб./год)">

        <template v-slot:buttons>
            <div v-if="check_roles([ 'model' ])" class="d-flex justify-content-center mb-2" style="gap: .625rem;">
                <b-button variant="outline-primary-secondary" v-on:click="() => $emit('update_counts')">
                    <span>Проверка заполненности</span><base-icon name="refresh" size="md" />
                </b-button>
            </div>
        </template>

        <statistic :total="analogues_count" :stats="[['', data.net_operating_income.analogues_count]]"
            :warning="!!(analogues_count - data.net_operating_income.analogues_count)"
			essense="объектов-аналогов"
        >
            <template v-slot:warning>
                <div style="line-height: 1.5rem;">
                    У части объектов-аналогов характеристика не заполнена.<br>
                    <!-- Дозаполните недостающие значения и проведите проверку снова или <i>настройте расчет чистого операционного дохода объектов-аналогов</i> ниже -->
                </div>
            </template>
        </statistic>

        <setup_frame v-if="!!(analogues_count - data.net_operating_income.analogues_count)"
            title="Настроить расчет чистого операционного дохода объектов-аналогов (руб./год)"
        >

            <div class="element-row mb-3">
                <label class="element-row_label"><span>Выберите способ расчета</span></label>
                <div class="element-row_fields">
                    <b-form-radio-group
                        :options="['С учетом доли операционных расходов', 'С учетом доли чистого операционного дохода']"
                        :checked="data.net_operating_income.type"
                        @change="(value) => set_value('net_operating_income.type', value)"
                        :disabled="!check_roles([ 'model' ])"
                    />
                </div>
            </div>

            <div v-if="data.net_operating_income.type == 'С учетом доли операционных расходов'">
                <element_row
                    title="Корректировка на величину недозагрузки и неплатежей" :data="data.net_operating_income.correction"
                    :validation="fields['net_operating_income.correction']" v-on:set_value="(key, value) => set_value(`net_operating_income.correction.${key}`, value)"
                    :readonly="!check_roles([ 'model' ])"
                />

                <element_row
                    title="Доля операционных расходов в действительном валовом доходе" :data="data.net_operating_income.operating_expenses_share"
                    :validation="fields['net_operating_income.operating_expenses_share']" v-on:set_value="(key, value) => set_value(`net_operating_income.operating_expenses_share.${key}`, value)"
                    :readonly="!check_roles([ 'model' ])"
                />
            </div>

            <div v-else-if="data.net_operating_income.type == 'С учетом доли чистого операционного дохода'">
                <element_row
                    title="Доля чистого операционного дохода в потенциальном валовом доходе" :data="data.net_operating_income.share"
                    :validation="fields['net_operating_income.share']" v-on:set_value="(key, value) => set_value(`net_operating_income.share.${key}`, value)"
                    :readonly="!check_roles([ 'model' ])"
                />
            </div>
            
        </setup_frame>

    </setup_content>
</template>

<script>

import setup_content from "../../setup_assets/content"
import setup_frame from "../../setup_assets/frame"
import statistic from "../../setup_assets/statistic"
import pair_groups from "./pair_groups"
import group_pairs from "./group_pairs"
import api from "../../../../../../api"
import element_row from "../../../../../widgets/element-row"

export default
{
	props :
	{
        id : String,
        group_id : String,
		data : Object,
        active_step : String,
		analogues_count : Number,
        not_editable : Boolean
	},

	components :
	{
        setup_content,
        setup_frame,
        statistic,
        pair_groups,
        group_pairs,
        element_row
	},

	data()
	{
		return {
            options : [
                'Метод рыночной экстракции (на основе группы пар данных)',
                'Метод рыночной экстракции (на основе пары групп данных)',
                'Метод кумулятивного построения',
                'Данные Пользователя'
            ],

            fields: {
                "custom":
                {
                    check: (value) => api.check_number({ value, accuracy : 4, gte : 0, lte : 1 }),
                    msg: "От 0 до 1, до 4-х знаков после запятой"
                },

                // #region Метод кумулятивного построения
                "cumulative.risk_free_rate":
                {
                    check: (value) => api.check_number({ value, gte : 0, lte : 1 }),
                    msg: "От 0 до 1"
                },
                "cumulative.premium":
                {
                    check: (value) => api.check_number({ value, gte : 0, lte : 1 }),
                    msg: "От 0 до 1"
                },
                "cumulative.total_risk":
                {
                    check: (value) => api.check_number({ value, gte : 0, lte : 1 }),
                    msg: "От 0 до 1"
                },
                "cumulative.norm":
                {
                    check: (value) => api.check_number({ value, gte : 0, lte : 1 }),
                    msg: "От 0 до 1"
                },
                // #endregion

                // #region Чистый операционный доход объектов-аналогов
                "net_operating_income.correction":
                {
                    check: (value) => api.check_number({ value, gte : 0, lte : 1 }),
                    msg: "От 0 до 1"
                },
                "net_operating_income.operating_expenses_share":
                {
                    check: (value) => api.check_number({ value, gte : 0, lte : 1 }),
                    msg: "От 0 до 1"
                },
                "net_operating_income.share":
                {
                    check: (value) => api.check_number({ value, gte : 0, lte : 1 }),
                    msg: "От 0 до 1"
                }
                // #endregion
            }
		}
	},

    computed :
    {
        not_editable_data()
        {
            if (this.data.type === this.options[2])
            {
                return { value : this.data.cumulative.value }
            }
            else if (this.data.type === this.options[3])
            {
                return this.data.custom
            }
            else
            {
                return { value : this.data.value }
            }
        }
    },

	methods :
	{
        
		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

        set_value(field, value)
        {
            this.$emit("set_value", field, value)
        }
	}
}

</script>
